// @flow
import { QuestionOpinometroActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    questionOpinometro: {},
    listaQuestionOpinometro: [],
    loading: false,
    loadingForm: false,
    error: false,
    formSubmited: false
};

type QuestionOpinometroAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { questionOpinometro?: {} | null, listaQuestionOpinometro?: [] | null, loading?: boolean, +value ?: boolean };

const QuestionOpinometro = (state: State = INIT_STATE, action: QuestionOpinometroAction): any => {
    // console.log(action);
    switch (action.type) {
        case QuestionOpinometroActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case QuestionOpinometroActionTypes.GET_QUESTION_OPINOMETRO: {
                    return {
                        ...state,
                        questionOpinometro: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case QuestionOpinometroActionTypes.LIST_QUESTION_OPINOMETROS: {
                    return {
                        ...state,
                        listaQuestionOpinometro: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case QuestionOpinometroActionTypes.ADD_QUESTION_OPINOMETRO: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case QuestionOpinometroActionTypes.UPDATE_QUESTION_OPINOMETRO: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case QuestionOpinometroActionTypes.DELETE_QUESTION_OPINOMETRO: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case QuestionOpinometroActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case QuestionOpinometroActionTypes.GET_QUESTION_OPINOMETRO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        questionOpinometro: {},
                        loading: false,
                    };
                }
                case QuestionOpinometroActionTypes.LIST_QUESTION_OPINOMETROS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaQuestionOpinometro: [],
                        loading: false,
                    };
                }
                case QuestionOpinometroActionTypes.ADD_QUESTION_OPINOMETRO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case QuestionOpinometroActionTypes.UPDATE_QUESTION_OPINOMETRO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case QuestionOpinometroActionTypes.DELETE_QUESTION_OPINOMETRO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case QuestionOpinometroActionTypes.GET_QUESTION_OPINOMETRO:
            return { ...state, error: false, loading: true };
        case QuestionOpinometroActionTypes.LIST_QUESTION_OPINOMETROS:
            return { ...state, error: false, loading: true };
        case QuestionOpinometroActionTypes.ADD_QUESTION_OPINOMETRO:
            return { ...state, error: false, loadingForm: true };
        case QuestionOpinometroActionTypes.UPDATE_QUESTION_OPINOMETRO:
            return { ...state, error: false, loadingForm: true };
        case QuestionOpinometroActionTypes.DELETE_QUESTION_OPINOMETRO:
            return { ...state, error: false, loading: true };
        case QuestionOpinometroActionTypes.RESET:
            return {
                ...state,
                loading: false,
                loadingForm: false,
                error: false,
                questionOpinometro: {},
                listaQuestionOpinometro: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default QuestionOpinometro;
